import api from "./api";

export function getCourse(data) {
    return api.post(`/studyprogram/filteredcourse`, data);
}

export function getSavedCourse(data) {
    return api.post(`/studyprogram/savedbookmarked`, data);
}

export function bookmarkCourseData(id) {
    return api.put(`/studyprogram/bookmark`, { studyProgramId: id });
}

export function getCourseData(id) {
    return api.get(`/studyprogram/getdata/${id}`);
}
